import { L2ASelfEvaluation } from './L2ASelfEvaluation';
import { L2ASelfEvaluationDoi } from './L2ASelfEvaluationDoi';
import { L2ASelfEvaluationSteps } from './L2ASelfEvaluationSteps';
import { SelfEvaluationCompleted } from './SelfEvaluationCompleted';
import { jsx as _jsx } from "react/jsx-runtime";
export function BannerContentL2A(props) {
  const {
    isSelfEvaluationCompleted,
    isDoi,
    selfInspection
  } = props;
  if (isSelfEvaluationCompleted) {
    return /*#__PURE__*/_jsx(SelfEvaluationCompleted, {});
  }
  if (selfInspection) {
    return /*#__PURE__*/_jsx(L2ASelfEvaluationSteps, {
      ...props
    });
  }
  if (isDoi) {
    return /*#__PURE__*/_jsx(L2ASelfEvaluationDoi, {
      ...props
    });
  }
  return /*#__PURE__*/_jsx(L2ASelfEvaluation, {
    ...props
  });
}